var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "info",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.75 20.5a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5m0-1.5a7.25 7.25 0 1 1 0-14.5 7.25 7.25 0 0 1 0 14.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 15.75v-4a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0m-.735-8.67a1.25 1.25 0 1 1-.035.001h.035z",
    clipRule: "evenodd"
  })));
};
export default SvgInfo;